import useQueries from "@/hooks/useQueries";
import { API_URL } from "@/shared/utils/API_URL";
import { buildQuery } from "@/shared/utils/buildQuery";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import Cookies from 'js-cookie';
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";


const fetchPlaces = async (sessionId: any, placesQuery: string, licenceId: any) => {
    const response = await axios.post(
        API_URL,
        { q: placesQuery },
        {
            headers: { 'Content-Type': 'application/json' },
            params: {
                t: 'sel',
                phone: '',
                id: licenceId,
                s: sessionId,
                btn: 'w_itm',
                api: 'itqan'
            },
        }
    );
    return response.data;
};

const executeUpdatePlace = async ({ sessionId, updatePlaceQuery, licenceId }: any) => {
    const response = await axios.post(
        API_URL,
        { q: updatePlaceQuery },
        {
            headers: { 'Content-Type': 'application/json' },
            params: { t: 'upd', phone: '', id: licenceId, s: sessionId, btn: 'w_itm', api: 'itqan' },
        }
    );
    return response.data;
};

const executeDeletePlace = async ({ sessionId, deletePlaceQuery, licenceId }: any) => {
    const response = await axios.post(
        API_URL,
        { q: deletePlaceQuery },
        {
            headers: { 'Content-Type': 'application/json' },
            params: { t: 'upd', phone: '', id: licenceId, s: sessionId, btn: 'w_itm', api: 'itqan' },
        }
    );
    return response.data;
};
const executeInsertPlace = async ({ sessionId, insertPlaceQuery, licenceId }: any) => {
    const response = await axios.post(
        API_URL,
        { q: insertPlaceQuery },
        {
            headers: { 'Content-Type': 'application/json' },
            params: { t: 'ins', phone: '', id: licenceId, s: sessionId, btn: 'w_itm', api: 'itqan' },
        }
    );
    return response.data;
};

export default function useShippingZonesController() {
    const { t } = useTranslation();

    const queryClient = useQueryClient();

    const queries = useQueries();
    const sessionId = Cookies.get('sessionId');
    const licenceId = localStorage.getItem("licence_id");

    const [managementDialog, setManagementDialog] = useState<{
        type: string;
        address_name?: string;
        shipping_fees?: number;
        id?: string | number;
    } | null>(null);

    const placesQuery = queries ? buildQuery(queries.placesQuery)
        : '';

    const { data, isLoading } = useQuery({
        queryKey: ['places', placesQuery, licenceId, sessionId],
        queryFn: () => fetchPlaces(sessionId, placesQuery, licenceId),
        enabled: !!placesQuery && !!sessionId && !!licenceId,
        staleTime: 0,
        refetchOnMount: true,
    });
    const places = data?.data?.result || [];


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, name: string) => {
        const value = e.target.value;
        setManagementDialog(prev => {
            if (!prev) return null;
            return { ...prev, [name]: value };
        });
    };

    const { mutate: updatePlace, isPending: isUpdating } = useMutation({
        mutationFn: ({ address_name, shipping_fees, address_id }: any) => {
            const updatePlaceQuery = buildQuery(queries.updatePlaceQuery,
                {
                    address_id: address_id,
                    address_name: address_name,
                    shipping_fees: shipping_fees
                });
            return executeUpdatePlace({ sessionId, updatePlaceQuery, licenceId });
        },
        onSuccess: () => {
            toast.success(t("Updated Successfully!"));
            queryClient.invalidateQueries({ queryKey: ['places'] });
            setManagementDialog(null);
        },
        onError: () => {
            toast.error(t("Something get wrong!"));
            setManagementDialog(null);
        },
    });


    const { mutate: insertPlace, isPending: isInserting } = useMutation({
        mutationFn: ({ address_name, shipping_fees }: any) => {
            const insertPlaceQuery = buildQuery(queries.insertPlaceQuery,
                {
                    address_name: address_name,
                    shipping_fees: shipping_fees
                });
            return executeInsertPlace({ sessionId, insertPlaceQuery, licenceId });
        },
        onSuccess: () => {
            toast.success(t("Added Successfully!"));
            queryClient.invalidateQueries({ queryKey: ['places'] });
            setManagementDialog(null);
        },
        onError: () => {
            toast.error(t("Something get wrong!"));
            setManagementDialog(null);
        },
    });



    const { mutate: deletePlace, isPending: isDeleting } = useMutation({
        mutationFn: ({ address_id }: any) => {
            const deletePlaceQuery = buildQuery(queries.deletePlaceQuery,
                {
                    address_id: address_id,
                });
            return executeDeletePlace({ sessionId, deletePlaceQuery, licenceId });
        },
        onSuccess: () => {
            toast.success(t("Deleted Successfully!"));
            queryClient.invalidateQueries({ queryKey: ['places'] });
            setManagementDialog(null);
        },
        onError: () => {
            toast.error(t("Something get wrong!"));
            setManagementDialog(null);
        },
    });

    const handleSubmitUpdatePlace = () => {
        if (!managementDialog?.id) return;
        updatePlace({
            address_name: managementDialog.address_name,
            shipping_fees: Number(managementDialog.shipping_fees) || 0,
            address_id: managementDialog.id
        });
    };

    const handleSubmitInsertPlace = () => {
        if (!managementDialog?.address_name) return;
        insertPlace({
            address_name: managementDialog.address_name,
            shipping_fees: Number(managementDialog.shipping_fees) || 0,
        });
    };

    const handleSubmitDeletePlace = () => {
        if (!managementDialog?.id) return;
        deletePlace({
            address_id: managementDialog.id
        });
    };


    const handleExport = (format: 'pdf' | 'excel', customTitle = 'تقرير مناطق التوصيل') => {
        if (!placesQuery) {
            toast.error(t("no_query_available"));
            return;
        }

        const cleanQuery = placesQuery
            .replace(/\s+LIMIT\s+\d+/gi, '')
            .replace(/\s+OFFSET\s+\d+/gi, '');

        const exportColumns = [
            { key: 'addressid', label: t('addressid') },
            { key: 'addressstring', label: t('addressstring') },
            { key: 'privilege', label: t('privilege') }
        ];

        const exportUrl = new URL("https://w-ord.ntelgnt.com/export.php");

        exportUrl.searchParams.append("format", format);
        exportUrl.searchParams.append("title", customTitle);
        exportUrl.searchParams.append("id", licenceId || "");
        exportUrl.searchParams.append("s", sessionId || "");

        const form = document.createElement("form");
        form.method = "POST";
        form.action = exportUrl.toString();
        form.target = "_blank";

        const qInput = document.createElement("input");
        qInput.type = "hidden";
        qInput.name = "q";
        qInput.value = cleanQuery;
        form.appendChild(qInput);

        const columnsInput = document.createElement("input");
        columnsInput.type = "hidden";
        columnsInput.name = "columns";
        columnsInput.value = JSON.stringify(exportColumns);
        form.appendChild(columnsInput);

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    };

    return {
        places,
        isLoading,
        placesQuery,
        managementDialog,
        isUpdating,
        isDeleting,
        isInserting,
        handleSubmitInsertPlace,
        handleSubmitUpdatePlace,
        handleChange,
        setManagementDialog,
        handleSubmitDeletePlace,
        handleExport
    }

}